import React from 'react';
import { LeadForm } from './LeadForm';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="contact" className="py-20 bg-navy relative overflow-hidden" data-id="element-81">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-indigo/10 skew-x-12 transform translate-x-20" data-id="element-82"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-steel/10 -skew-x-12 transform -translate-x-20" data-id="element-83"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-84">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-85">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-white" data-id="element-86">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-87">
              Tu tranquilidad, es nuestra misión
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-88">
              No dejes que la burocracia frene tus planes. Agenda una llamada
              gratuita con nuestros expertos y descubre cómo podemos ayudarte
              hoy mismo.
            </p>

            <div className="space-y-4" data-id="element-89">
              <div className="flex items-center gap-4 p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-90">
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-xl" data-id="element-91">
                  1
                </div>
                <div data-id="element-92">
                  <h4 className="font-bold text-lg" data-id="element-93">Rellena el formulario</h4>
                  <p className="text-gray-400 text-sm" data-id="element-94">
                    Cuéntanos brevemente qué necesitas.
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-95">
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-xl" data-id="element-96">
                  2
                </div>
                <div data-id="element-97">
                  <h4 className="font-bold text-lg" data-id="element-98">Analizamos tu caso</h4>
                  <p className="text-gray-400 text-sm" data-id="element-99">
                    Estudiamos la viabilidad sin compromiso.
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-100">
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-xl" data-id="element-101">
                  3
                </div>
                <div data-id="element-102">
                  <h4 className="font-bold text-lg" data-id="element-103">Te damos soluciones</h4>
                  <p className="text-gray-400 text-sm" data-id="element-104">
                    Recibe una propuesta clara y transparente.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-105">
            <LeadForm data-id="element-106" />
          </motion.div>
        </div>
      </div>
    </section>;
}